import { BaseEntity } from "@app/models/rest/base-entity";
import { SubDivision } from "@app/models/rest/roster/sub-division";
import { ResourceModel } from "@app/models/rest/resource";
import { HateoasResource } from "@lagoshny/ngx-hateoas-client";

@HateoasResource("rosterAssignments")
export class RosterAssignment extends BaseEntity {
  public subDivision: SubDivision;
  public resource: ResourceModel;
  public startDate: Date;
  public endDate: Date;
  public lastRunDate: Date;
}
